import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Heart } from "lucide-react";
import { ASSETS } from "@/lib/content";

export const Footer = () => (
  <footer className="bg-black border-t border-white/10 mt-24" data-testid="footer">
    {/* Brand block — top center */}
    <div className="max-w-3xl mx-auto px-6 pt-16 pb-10 text-center flex flex-col items-center">
      <div className="flex items-center justify-center gap-3 mb-5">
        <img src={ASSETS.moon} alt="" className="h-12 w-auto object-contain" />
        <span className="font-serif text-2xl tracking-[0.2em] text-cream">AFTER DARK</span>
      </div>
      <p className="font-serif italic text-gold/80 text-base mb-4">
        "Sinfully sculpted for your naughty pleasure"
      </p>
      <p className="font-body text-sm text-white/50 leading-relaxed max-w-md">
        Luxury adult novelty chocolates, handcrafted for grown-up indulgence. Proudly inclusive — all adult lovers celebrated.
      </p>
    </div>

    {/* Menu options — below */}
    <div className="max-w-5xl mx-auto px-6 pb-16 grid grid-cols-1 sm:grid-cols-3 gap-10 text-center border-t border-white/10 pt-12">
      <div>
        <h4 className="font-body uppercase tracking-[0.2em] text-xs text-champagne mb-4">Explore</h4>
        <ul className="space-y-2.5 font-body text-sm text-white/60">
          <li><Link to="/shop" className="hover:text-gold transition-colors">Shop All</Link></li>
          <li><Link to="/about" className="hover:text-gold transition-colors">About</Link></li>
        </ul>
      </div>

      <div>
        <h4 className="font-body uppercase tracking-[0.2em] text-xs text-champagne mb-4">Care</h4>
        <ul className="space-y-2.5 font-body text-sm text-white/60">
          <li><Link to="/contact" className="hover:text-gold transition-colors">Contact Us</Link></li>
          <li><span className="text-white/60">International Shipping</span></li>
          <li><span className="text-white/60">Discreet Packaging</span></li>
        </ul>
      </div>

      <div>
        <h4 className="font-body uppercase tracking-[0.2em] text-xs text-champagne mb-4">After Hours</h4>
        <p className="font-body text-sm text-white/60 mb-4">Whispers of new temptations, delivered rarely.</p>
        <div className="flex gap-4 text-cream justify-center">
          <a href="https://instagram.com/afterdarkchocolate" target="_blank" rel="noopener noreferrer" aria-label="Instagram" data-testid="footer-instagram" className="hover:text-gold transition-colors"><Instagram className="w-5 h-5" strokeWidth={1.5} /></a>
        </div>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-2">
        <p className="font-body text-xs text-white/40">© {new Date().getFullYear()} After Dark Chocolates. 18+ only.</p>
        <p className="font-body text-xs text-white/40 flex items-center gap-1.5">
          Made with <Heart className="w-3 h-3 text-gold fill-gold" /> for every kind of lover
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
